/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  ListMCPCatalogRequest,
  ListMCPCatalogSecurity,
} from "../models/operations/listmcpcatalog.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildListMCPCatalogQuery,
  ListMCPCatalogQueryData,
  prefetchListMCPCatalog,
  queryKeyListMCPCatalog,
} from "./listMCPCatalog.core.js";
export {
  buildListMCPCatalogQuery,
  type ListMCPCatalogQueryData,
  prefetchListMCPCatalog,
  queryKeyListMCPCatalog,
};

export type ListMCPCatalogQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * listCatalog mcpRegistries
 *
 * @remarks
 * List available MCP servers from configured registries
 */
export function useListMCPCatalog(
  request?: ListMCPCatalogRequest | undefined,
  security?: ListMCPCatalogSecurity | undefined,
  options?: QueryHookOptions<ListMCPCatalogQueryData, ListMCPCatalogQueryError>,
): UseQueryResult<ListMCPCatalogQueryData, ListMCPCatalogQueryError> {
  const client = useGramContext();
  return useQuery({
    ...buildListMCPCatalogQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * listCatalog mcpRegistries
 *
 * @remarks
 * List available MCP servers from configured registries
 */
export function useListMCPCatalogSuspense(
  request?: ListMCPCatalogRequest | undefined,
  security?: ListMCPCatalogSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    ListMCPCatalogQueryData,
    ListMCPCatalogQueryError
  >,
): UseSuspenseQueryResult<ListMCPCatalogQueryData, ListMCPCatalogQueryError> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildListMCPCatalogQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setListMCPCatalogData(
  client: QueryClient,
  queryKeyBase: [
    parameters: {
      registryId?: string | undefined;
      search?: string | undefined;
      cursor?: string | undefined;
      gramSession?: string | undefined;
      gramKey?: string | undefined;
      gramProject?: string | undefined;
    },
  ],
  data: ListMCPCatalogQueryData,
): ListMCPCatalogQueryData | undefined {
  const key = queryKeyListMCPCatalog(...queryKeyBase);

  return client.setQueryData<ListMCPCatalogQueryData>(key, data);
}

export function invalidateListMCPCatalog(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: {
      registryId?: string | undefined;
      search?: string | undefined;
      cursor?: string | undefined;
      gramSession?: string | undefined;
      gramKey?: string | undefined;
      gramProject?: string | undefined;
    }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "mcpRegistries", "listCatalog", ...queryKeyBase],
  });
}

export function invalidateAllListMCPCatalog(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "mcpRegistries", "listCatalog"],
  });
}
